import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../assets/audio/bites.mp3'


const _hoisted_1 = { class: "w-screen h-screen flex justify-center items-center" }
const _hoisted_2 = { class: "md:w-[750px] border-2 border-black md:h-80 md:p-2 p-4 bg-gray" }
const _hoisted_3 = {
  id: "player-ui",
  class: "bg-blackBg mt-4 flex flex-col md:flex-row items-center justify-between"
}
const _hoisted_4 = { class: "flex flex-col w-full justify-between md:w-1/4 pl-3" }
const _hoisted_5 = { class: "text-skyBlue text-6xl font-techMono text-center" }
const _hoisted_6 = { class: "w-full md:w-[185px] h-16 relative" }
const _hoisted_7 = {
  hidden: "",
  ref: "foo",
  preload: "auto",
  id: "audio-player"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("source", {
  src: _imports_0,
  type: "audio/mpeg"
}, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col mr-2\"><div class=\"overflow-x-hidden\"><p class=\"text-skyBlue text-3xl font-techMono self-end animate-paragraph\"> Another One Bites The Dust -Queen </p></div><div class=\"flex space-x-4 self-end items-center\"><i class=\"fa-solid fa-play text-skyBlue changePlayIcon\"></i><p class=\"text-skyBlue font-techMono\"> 192<span class=\"text-gray\">KBPS</span></p><p class=\"text-skyBlue font-techMono\"> 44<span class=\"text-gray\">Khz</span></p><p><i class=\"fa-solid fa-infinity text-skyBlue\"></i><span class=\"text-gray\">STEREO</span></p></div></div>", 1)
const _hoisted_12 = { class: "rounded-lt-md w-full md:w-[320px] h-14 self-end bg-gray flex items-center space-x-4 px-2 mt-2" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-volume-high text-greyDark text-l muteIcon" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = { class: "mt-3 p-2" }
const _hoisted_16 = { class: "flex justify-between mt-3" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("button", { class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-backward-fast text-greyDark text-xl" })
], -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-play text-greyDark text-xl" }, null, -1)
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-pause text-greyDark text-xl" }, null, -1)
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-stop text-greyDark text-xl" }, null, -1)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = /*#__PURE__*/_createElementVNode("button", { class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-forward-fast text-greyDark text-xl" })
], -1)
const _hoisted_26 = { class: "flex space-x-4" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("button", { class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-eject text-greyDark text-xl" })
], -1)
const _hoisted_28 = { class: "flex" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", { class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-person-walking-arrow-loop-left text-greyDark text-xl" })
], -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-arrow-rotate-left text-greyDark text-xl loopBtn" }, null, -1)
const _hoisted_31 = [
  _hoisted_30
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheNavigationBar = _resolveComponent("TheNavigationBar")!
  const _component_av_bars = _resolveComponent("av-bars")!
  const _component_vue_slider = _resolveComponent("vue-slider")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TheNavigationBar),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.duration), 1),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("audio", _hoisted_7, _hoisted_9, 512),
            _createVNode(_component_av_bars, {
              "caps-color": "#a7c8d5",
              "bar-color": 'rgb(128,143,146)',
              "caps-height": 4,
              "ref-link": "foo",
              "brick-height": _ctx.brickHeight,
              "bar-width": 10,
              "bar-space": 6,
              "canv-height": _ctx.canvaHeight,
              "canv-width": 190,
              style: {"text-align":"center"}
            }, null, 8, ["bar-color", "brick-height", "canv-height"])
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              class: "flex items-center px-2 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.mute && _ctx.mute(...args)))
            }, _hoisted_14),
            _createVNode(_component_vue_slider, {
              modelValue: _ctx.volumeValue,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.volumeValue) = $event)),
              min: 0,
              max: 200,
              style: {"width":"100%"},
              onChange: _ctx.changeVolume,
              onDragging: _ctx.changeVolume
            }, null, 8, ["modelValue", "onChange", "onDragging"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _createVNode(_component_vue_slider, {
          modelValue: _ctx.audioValue,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.audioValue) = $event)),
          max: 100,
          tooltip: "none",
          onDragging: _ctx.changePosition,
          onChange: _ctx.changePosition
        }, null, 8, ["modelValue", "onDragging", "onChange"])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("button", {
            class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.playAudio && _ctx.playAudio(...args)))
          }, _hoisted_20),
          _createElementVNode("button", {
            class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.pauseAudio && _ctx.pauseAudio(...args)))
          }, _hoisted_22),
          _createElementVNode("button", {
            class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stopAudio && _ctx.stopAudio(...args)))
          }, _hoisted_24),
          _hoisted_25
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _hoisted_29,
            _createElementVNode("button", {
              class: "flex items-center px-4 py-2 h-10 bg-gradient-to-b from-silverBtns to-grey rounded-md border-2 border-gray",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.loop && _ctx.loop(...args)))
            }, _hoisted_31)
          ])
        ])
      ])
    ])
  ]))
}